import { type AnyAction } from 'redux';

interface IState {
  parcelStatus: Array<{ label: string; value: string }>;
  companyTableFilter: string | undefined;
  riderTableFilter: string | undefined;
  statusTableFilter: string | undefined;
  areaTableFilter: string | undefined;
  balanceFilter: string | undefined;
  last_delivery_charge: number;
  last_company: any;
  parcelTableSort: string;
  parcelTableLimit: number;
  parcelTablePage: number;
}

export const initState = {
  parcelStatus: [
    { label: 'ON DELIVERY', value: 'ON_DELIVERY' },
    { label: 'DELIVERED', value: 'DELIVERED' },
    { label: 'PARTIALLY DELIVERED', value: 'PARTIALLY_DELIVERED' },
    { label: 'RETURNED', value: 'RETURNED' },
    { label: 'BOOKING', value: 'BOOKING' },
    { label: 'PICKED', value: 'PICKED' },
    { label: 'PENDING', value: 'PENDING' },
    { label: 'DELIVERED_BY_RIDER', value: 'DELIVERED_BY_RIDER' },
    { label: 'PARTIAL DEL. BY RIDER', value: 'PARTIALLY_DELIVERED_BY_RIDER' },
    { label: 'RETURNED_BY_RIDER', value: 'RETURNED_BY_RIDER' },
  ],
  companyTableFilter: undefined,
  riderTableFilter: undefined,
  statusTableFilter: undefined,
  areaTableFilter: undefined,
  balanceFilter: undefined,
  last_delivery_charge: 80,
  last_company: undefined,
  parcelTableSort: 'id:DESC',
  parcelTableLimit: 10,
  parcelTablePage: 1,
};

export default function parcelReducer(state: IState = initState, action: AnyAction): IState {
  switch (action.type) {
    case 'UPDATE_COMPANY_TABLE_FILTER':
      return { ...state, companyTableFilter: action.payload };
    case 'UPDATE_RIDER_TABLE_FILTER':
      return { ...state, riderTableFilter: action.payload };
    case 'UPDATE_STATUS_TABLE_FILTER':
      return { ...state, statusTableFilter: action.payload };
    case 'UPDATE_AREA_TABLE_FILTER':
      return { ...state, areaTableFilter: action.payload };
    case 'UPDATE_BALANCE_TABLE_FILTER':
      return { ...state, balanceFilter: action.payload };
    case 'UPDATE_LAST_DELIVERY_CHARGE':
      return { ...state, last_delivery_charge: action.payload };
    case 'UPDATE_LAST_COMPANY':
      return { ...state, last_company: action.payload };
    case 'UPDATE_PARCEL_TABLE_SORT':
      return { ...state, parcelTableSort: action.payload };
    case 'UPDATE_PARCEL_TABLE_LIMIT':
      return { ...state, parcelTableLimit: action.payload };
    case 'UPDATE_PARCEL_TABLE_PAGE':
      return { ...state, parcelTablePage: action.payload };
    default:
      return state;
  }
}
